// Mega Menu Off Canvas 

$(function() {      
    let isMobile = window.matchMedia("only screen and (max-width: 992px)").matches;

    if (!isMobile) {
        $(window).scroll(function(event){
            var st = $(this).scrollTop();
            if (st > 10){
                $('nav.navbar-expanded').css('background-color', '#000');
                // $('#mega-menu-container').removeClass('show');
                $('nav.navbar-primary-menu > div').removeClass('p-2 pt-lg-4');
                $('nav.navbar-primary-menu > div').addClass('p-0');
            } else {
                $('nav.navbar-primary-menu > div').addClass('p-2 pt-lg-4');
                $('nav.navbar-primary-menu > div').removeClass('p-0');
                $('nav.navbar-expanded').css('background-color', 'transparent');
            }
        });
        $('#mega-menu-right li.menu-item-has-children > a').each(function(e, el) {
            $(el).attr('data-toggle', '');
        });


        $('#show-search-form-404').on('click', function(){
            $("#search-form-404").toggleClass('show');
            $(this).toggleClass('d-none');
        });

        // $('div.cta-pill-actions.show').on('mousemove', function(e){
        //     var pos = $(this).position();
        //     var parent_width = $(this).width();
        //     var left = e.pageX; 
        //     var size = $('div.cta-pill-actions.show div.pills-background').width();
        //     var els = Math.ceil(parent_width / size);
        //     var res = 0;
        //     for (let i = 0; i < els; i++) {
        //       if((left - pos.left) > (size * i)) {
        //         res = size * i;
        //       }
        //     }
        //     console.log("l:"+left, "s:"+size, "r:"+res);
        //     if(res < (size/2)) {
        //         res = 0;
        //     }
        //     if(res == 0) {
        //         $('div.cta-pill-actions.show .it-0 p.bold').css('color', '#fff');
        //     } else {
        //         $('div.cta-pill-actions.show .it-0 p.bold').css('color', '#e41d5e');
        //     }

        //     $('div.cta-pill-actions.show div.pills-background').css('display', 'block');
        //     $('div.cta-pill-actions.show div.pills-background').css('left', res);
        // });
        // $('div.cta-pill-actions.show').on('mouseleave', function(e){
        //     $('div.pills-background').css('display', 'none');
        //     $('div.cta-pill-actions.show .it-0 p.bold').css('color', '#e41d5e');
        //     $('div.cta-pill-actions.show div.pills-background').css('left', 0);
        // });

        // $('.cta-pill-actions').on('shown.bs.collapse', function () {
        //     $('div.pills-background').css('display', 'none');
        //     $('div.pills-background').css('left', 0);
        //     $('div.cta-pill-actions.show').on('mousemove', function(e){
        //         var pos = $(this).position();
        //         var parent_width = $(this).width();
        //         var left = e.pageX; 
        //         var size = $('div.cta-pill-actions.show div.pills-background').width();
        //         var els = Math.ceil(parent_width / size);
        //         var res = 0;
        //         for (let i = 0; i < els; i++) {
        //           if((e.pageX - pos.left) > (size * i)) {
        //             res = size * i;
        //           }
        //         }
        //         if(res < (size/2)) {
        //             res = 0;
        //         }
        //         if(res == 0) {
        //         $('div.cta-pill-actions.show .it-0 p.bold').css('color', '#fff');
        //         } else {
        //             $('div.cta-pill-actions.show .it-0 p.bold').css('color', '#e41d5e');
        //         }
        //         $('div.cta-pill-actions.show div.pills-background').css('display', 'block');
        //         $('div.cta-pill-actions.show div.pills-background').css('left', res);
        //     });
        //     $('div.cta-pill-actions.show').on('mouseleave', function(e){
        //         $('div.pills-background').css('display', 'none');
        //         $('div.cta-pill-actions.show .it-0 p.bold').css('color', '#e41d5e');
        //         $('div.cta-pill-actions.show div.pills-background').css('left', 0);
        //     });
        // });
        $('div.cta-pill-actions.show .ct-hov').hover(
            function(e){ 
                $('div.cta-pill-actions.show div.pills-background').css('left', $(this).position().left );
                $('div.cta-pill-actions.show .it-0 p.bold').css('color', '#e41d5e');
                $('div.cta-pill-actions.show a.ct-hov:nth-child(1) p.bold').css('color', '#e41d5e');
            },
            function(e){ 
                $('div.cta-pill-actions.show div.pills-background').css('left', 0 );
                $('div.cta-pill-actions.show a.ct-hov:nth-child(1) p.bold').css('color', '#fff');
            }
        );

        $('.cta-pill-actions').on('shown.bs.collapse', function () {
            $('div.cta-pill-actions.show a.ct-hov:nth-child(1) p.bold').css('color', '#fff');
            $('div.cta-pill-actions.show .ct-hov').hover(
                function(e){ 
                    $('div.cta-pill-actions.show div.pills-background').css('left', $(this).position().left );
                    $('div.cta-pill-actions.show .it-0 p.bold').css('color', '#e41d5e');
                    $('div.cta-pill-actions.show a.ct-hov:nth-child(1) p.bold').css('color', '#e41d5e');
                },
                function(e){ 
                    $('div.cta-pill-actions.show div.pills-background').css('left', 0);
                    $('div.cta-pill-actions.show a.ct-hov:nth-child(1) p.bold').css('color', '#fff');
                }
            );
        });
    }

    if(isMobile) {
        $('.cta-action-hidden-desktop').click(
            function(e){ 
                $('div.cta-pill-actions.show div.pills-background').css('left', $(this).position().left );
                $('div.cta-pill-actions.show p.bold').css('color', '#e41d5e');
                var dt = new Date().getTime();
                $(this).attr('id', dt);
                $('#'+dt+' p.bold').css('color', '#fff');
            }
        );
        $('#mega-menu-right ul.sub-menu').each(function(e, el) {
            $(el).removeClass('show');
        })
        // Clickable parent menus
        // $('.navbar .dropdown').hover(function() {
        // $(this).find('.dropdown-menu').first().stop(true, true).delay(250).slideDown();

        // }, function() {
        // $(this).find('.dropdown-menu').first().stop(true, true).delay(100).slideUp();

        // });

        $('li.menu-item-has-children > a').click(function(){
            location.href = this.href;
        });

    }

    // SA Block filtering
    
    $('.sortable-area-category').click(function(e){
        var instance_category = $(this).attr("category-slug");
        var taxonomy = $(this).attr("taxonomy-name");
        var post_type = $(this).attr("post_type");
        var target = $('#insurance_results');
        $('.ins-spinner').toggleClass('d-none');
        $('.sortable-area-category').each(function(e, el) {
            $(el).removeAttr('active');
        })
        var pg = $('#pg').val();
        var exclude_categories = $('#sa-exclude-categories').val();
        $(this).attr('active', '');
        e.preventDefault();
        $.post(
            SortableAreaAjax.ajaxurl,
            {
                action : 'insurance_ajax_search',
                search_val : instance_category,
                tax_name : taxonomy,
                post_type : post_type,
                pg: pg,
                exclude_categories: exclude_categories
            },
            function( response ) {
                target.html( response );
                $('.ins-spinner').toggleClass('d-none');
            }
        );
    });

    // SA Block Load more

    $('.sortable-area-load-more').click(function(e){
        var instance_category = $('a.sortable-area-category[active]').attr("category-slug");
        var taxonomy = $('a.sortable-area-category[active]').attr("taxonomy-name");
        var post_type = $('a.sortable-area-category[active]').attr("post_type");
        if(post_type === undefined) {
            post_type = $(this).attr("post_type");
        }
        var offset = $(this).attr('offset');
        var pg = $('#pg').val();
        var it = $(this).attr('it');
        var target = $('#insurance_results');
        $('.lm-spinner').toggleClass('d-none');
        $(this).attr('it', Number(it)+1);
        e.preventDefault();
        $.post(
            SortableAreaAjax.ajaxurl,
            {
                action : 'insurance_ajax_search',
                search_val : instance_category,
                tax_name : taxonomy,
                post_type : post_type,
                pg: pg,
            },
            function( response ) {
                target.append( response );
                $('.lm-spinner').toggleClass('d-none');
            }
        );
    });

    // SA Block Pagination

    $('.sa-pagination .page-item:not("active") a.page-link').click(function(e){
        var instance_category = $('a.sortable-area-category[active]').attr("category-slug");
        var taxonomy = $('a.sortable-area-category[active]').attr("taxonomy-name");
        var post_type = $('a.sortable-area-category[active]').attr("post_type");
        if(post_type === undefined) {
            post_type = $('#bp_input').val();
        }
        var offset = $('#p_offset').val();
        var paged = $(this).attr('href').replace('#', '');
        var target = $('#insurance_results');
        var pg = $('#pg').val();
        var exclude_categories = $('#sa-exclude-categories').val();
        $('.lm-spinner').toggleClass('d-none');
        e.preventDefault();
        $.post(
            SortableAreaAjax.ajaxurl,
            {
                action : 'insurance_ajax_search',
                search_val : instance_category,
                tax_name : taxonomy,
                post_type : post_type,
                paged : paged,
                ppage: offset,
                pg: pg,
                exclude_categories: exclude_categories
            },
            function( response ) {8
                target.html( response );
                $('.lm-spinner').toggleClass('d-none');
            }
        );
    });

    $('.sidebar-category-select').change(function(e){
        var instance_category = $('option:selected', this).attr('category-slug');
        var title = $('option:selected', this).text();
        var taxonomy = 'category';
        var post_type = 'post';
        var it = 3;
        var target = $('#sidebar-cats-latest-posts');
        e.preventDefault();
        $.post(
            SortableAreaAjax.ajaxurl,
            {
                action : 'insurance_ajax_search',
                search_val : instance_category,
                tax_name : taxonomy,
                post_type : post_type,
                title: title,
                it : it,
                spl : 1
            },
            function( response ) {
                target.html( response );
            }
        );
    });

    // Pills keep one opened
    $(".pills-switch").click(
        function() {
           if($(this).attr('aria-expanded') == "true") {
               event.stopPropagation();  
               event.preventDefault();
           }
           $('div.cta-pill-actions.show a.ct-hov:nth-child(1) p.bold').css('color', '#fff');
        }
    );
    $(".pills-switch").hover(
        function() {
            if($(this).attr('aria-expanded') == "true") {
               event.stopPropagation();  
               event.preventDefault();
            } else {
                $(this).trigger('click');
            }
        },
        function() {
            
        }
    );

    $('#mega-menu-container').on('show.bs.collapse', function () {
        $("#site-navigation").css('height', '100vh');
        // $(this).css('padding-top', '90px');
    });

    $('#mega-menu-container').on('hidden.bs.collapse', function () {
        $("#site-navigation").css('height', 'auto');
        // $(this).css('padding-top', 'unset');
    });

    $('#mega-menu-container').on('shown.bs.collapse', function () {
        $('body').css('overflow-y', 'hidden');
        $('body').css('animation', 'hide-scroll 0.7s backwards');
    });

    $('#mega-menu-container').on('hide.bs.collapse', function () {
        $('body').css('overflow-y', 'auto');
    });

    $('.bookother').click(function(e){
        var hidden_data = $(this).attr("hd-data");
        $('#input_53_14').val(hidden_data);
    });


});

    // var cw = window.hero_rating_menu.clientWidth; // save original 100% pixel width

    // function set_hero_rating_menu( stars ) {
    //   // window.hero_rating_menu.style.width = Math.round(cw * (stars / 5)) + 'px';
    //   // document.getElementById("hero_rating_menu_value").textContent = stars;
    // }
    // set_hero_rating_menu(4.8);

    // var cw = window.hero_rating.clientWidth; // save original 100% pixel width

    // function set_hero_rating( stars ) {
    //   window.hero_rating.style.width = Math.round(cw * (stars / 5)) + 'px';
    //   document.getElementById("hero_rating_value").textContent = stars;
    // }

jQuery.fn.extend({
    getPath: function () {
        var path, node = this;
        while (node.length) {
            var realNode = node[0], name = realNode.name;
            if (!name) break;
            name = name.toLowerCase();

            var parent = node.parent();

            var sameTagSiblings = parent.children(name);
            if (sameTagSiblings.length > 1) { 
                var allSiblings = parent.children();
                var index = allSiblings.index(realNode) + 1;
                if (index > 1) {
                    name += ':nth-child(' + index + ')';
                }
            }

            path = name + (path ? '>' + path : '');
            node = parent;
        }

        return path;
    }
});